module.exports = require("npm:es6-promise@3.1.2/dist/es6-promise.js");